module.exports = __webpack_public_path__ + "img/mapping.ed3a4930.svg";